import { render } from "./loadScreenComponent.vue?vue&type=template&id=01f796ef"
import script from "./loadScreenComponent.vue?vue&type=script&lang=js"
export * from "./loadScreenComponent.vue?vue&type=script&lang=js"

import "./loadScreenComponent.vue?vue&type=style&index=0&id=01f796ef&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__